import type { TickerSuggestion } from "@/shared/lib/types";

/** Decode customer-safe ticker lookup data without deriving domain identity. */
export function decodeTickerSuggestion(value: unknown): TickerSuggestion | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const candidate = value as Record<string, unknown>;
  if (typeof candidate.ticker !== "string" || !candidate.ticker.trim()) return null;

  const suggestion: TickerSuggestion = {
    ticker: candidate.ticker.trim().toUpperCase(),
  };
  if (typeof candidate.name === "string" && candidate.name.trim()) {
    suggestion.name = candidate.name.trim();
  }
  for (const field of ["market", "type", "locale", "primary_exchange"] as const) {
    if (typeof candidate[field] === "string") suggestion[field] = candidate[field];
  }
  if (typeof candidate.active === "boolean") suggestion.active = candidate.active;

  const rawIdentity = candidate.listing_identity;
  if (rawIdentity && typeof rawIdentity === "object" && !Array.isArray(rawIdentity)) {
    const identity = rawIdentity as Record<string, unknown>;
    if (typeof identity.mic_code === "string"
      && typeof identity.asset_type === "string"
      && typeof identity.country_code === "string") {
      suggestion.listing_identity = {
        mic_code: identity.mic_code,
        asset_type: identity.asset_type,
        country_code: identity.country_code,
      };
    }
  }
  return suggestion;
}
